export default theme => ({
  formControl: {
    maxWidth: '400px',
  },
});
